// src/contexts/MessagingPhaseContext.js
import React, { createContext, useState, useContext, useMemo } from 'react';

const MessagingPhaseContext = createContext(undefined); // It's good practice to provide an initial undefined value

export const MessagingPhaseProvider = ({ children }) => {
  const [currentPhase, setCurrentPhase] = useState(
    // MODIFIED: Default to phase1_nexus_centric for production. Local storage can still override for dev testing.
    localStorage.getItem('glonetMessagingPhase') || 'phase1_nexus_centric'
  );

  const setMessagingPhase = (phase) => {
    if (phase === 'phase0_event_centric' || phase === 'phase1_nexus_centric') {
      setCurrentPhase(phase);
      localStorage.setItem('glonetMessagingPhase', phase);
      // Forcing a reload to ensure i18next picks up the new defaultNS
      // or that components re-request translations with the new namespace.
      // A more sophisticated approach might involve directly telling i18next to change
      // its default namespace and reload resources, but reload is simplest for now.
      window.location.reload(); 
    } else {
      console.error("Invalid messaging phase attempted:", phase);
    }
  };

  const value = useMemo(() => ({ currentPhase, setMessagingPhase }), [currentPhase]);

  return (
    <MessagingPhaseContext.Provider value={value}>
      {children}
    </MessagingPhaseContext.Provider>
  );
};

export const useMessagingPhase = () => { // This is the named export
  const context = useContext(MessagingPhaseContext);
  if (context === undefined) {
    throw new Error('useMessagingPhase must be used within a MessagingPhaseProvider');
  }
  return context;
};

// You could also have a default export if needed for other purposes,
// but for these specific named imports, the above is sufficient.
// For example:
// export default MessagingPhaseContext; // If you wanted to export the context itself